module.exports = __webpack_public_path__ + "assets/img/icon_门户列表@2x.d99ee5db.png";